import {Provider} from "./provider";
import {log} from "../../util/log";

interface IIOSMessage {
    command: string;
    name: string;
    parameters: string;
}

export class IOSProvider extends Provider {
    /* STATIC */

    /* INSTANCE */
    override configure(value: boolean) {
        const webkit = (window as any)['webkit'];
        if (webkit
            && webkit.messageHandlers
            && webkit.messageHandlers.firebase) {
            const msg: IIOSMessage = {
                command: 'configureConsentMode',
                name: 'consentMode',
                parameters: `${value}`
            };
            webkit.messageHandlers.firebase.postMessage(msg);
        } else {
            log.debug('webkit.messageHandlers.firebase not found');
        }
    }
}
